// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"4059f5aa","47":"db9d7123","181":"997a4ab0","323":"dce49ea6","336":"71281b77","597":"5ba8b12a","807":"743193b0","923":"73ea93d7","989":"9fc054e5"}[chunkId] + ".chunk.js";
};